import common from "../common";

import Scene from "./Scene";

export default class DemoScene extends Scene {
    constructor() {
        super();
    }

    init() {
        super.init();

        this._shaggy = new PIXI.spine.Spine(P3.assets.spineData("shaggy"));
        this._shaggy.autoUpdate = false;
        this._shaggy.skeleton.setSkinByName("regular");
        this._shaggy.state.setAnimation(0, "running", true);
        this._shaggy.update(0);
        this._shaggy.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 20);
        this.addChild(this._shaggy);

        this._grounded = true;

        this._floor = this._shaggy.y;
        this._gravity = 1900;

        this._shaggy.velocity = new PIXI.Point();

        const test = new PIXI.Sprite(P3.assets.texture("spider_web"));
        test.anchor.set(0.5, 0.5);
        test.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(test);
    }

    resize() {
        super.resize();

    }

    animateIn() {

    }

    end() {

    }

    update(dt = window.deltaTime) {
        super.update();
        this._shaggy.update(dt);

        this._shaggy.velocity.y += this._gravity * dt;
        this._shaggy.y += this._shaggy.velocity.y * dt;

        if (this._shaggy.y >= this._floor) {
            this._shaggy.y = this._floor;
            if (!this._grounded) {
                this._shaggy.state.setAnimation(0, "landing", false);
                this._shaggy.state.addAnimation(0, "running", true, 0);
            }
            this._grounded = true;
        } else {
            this._grounded = false;
        }

        if (this._grounded && P3.input.isKeyPressed(P3.keys.SPACE)) {
            this._shaggy.velocity.y = -600;
            this._shaggy.state.setAnimation(0, "jump", false);
        }
    }


}

